export default __webpack_public_path__ + "static/media/aircraft_plant_9.5709e4f1.png";